import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FracClusterTruckingVendor } from '~lmo/models/frac.model';
import { LmoFracFctvsService } from '~lmo/services/lmo-frac-fctvs.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac-fctv-manage',
  styleUrls: ['./lmo-frac-fctv-manage.component.scss'],
  templateUrl: './lmo-frac-fctv-manage.component.html',
})
export class LmoFracFctvManageComponent implements OnInit {
  public fracClusterTruckingVendors$: Observable<FracClusterTruckingVendor[]>;

  constructor(private fctvService: LmoFracFctvsService) {}

  public ngOnInit() {
    this.fracClusterTruckingVendors$ = this.fctvService.currentFracFctvs$.pipe(
      map((fctvs) => fctvs.filter((fctv) => this.isAwarded(fctv) || this.isPending(fctv))),
    );
  }

  public isAwarded(fctv: FracClusterTruckingVendor) {
    return fctv.status === 'awarded';
  }

  public isPending(fctv: FracClusterTruckingVendor) {
    return fctv.status === 'pending';
  }
}
